'use es6';

import { Component, Fragment } from 'react';
import { OperationPropType, OasPropType } from '../../../lib/api-explorer/models/Oas';
import { getResponseExamples } from '../../Doc/utils/ExampleUtils';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UISelect from 'UIComponents/input/UISelect';
import LanguagePicker from '../../CodeSample/components/LanguagePicker';
import CodeMirror from '../../CodeSample/components/CodeMirror';
import LazyLoadWrapper from './LazyLoadWrapper';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class ExampleResponse extends Component {
  constructor(props) {
    super(props);
    this.getInitialState = () => {
      const state = {
        selectedResponseCode: null,
        selectedResponseMediaType: null
      };
      if (this.responseCodeOptions.length) {
        state.selectedResponseCode = this.responseCodeOptions[0];
        if (this.examples[state.selectedResponseCode].mediaTypes.length) {
          state.selectedResponseMediaType = this.examples[state.selectedResponseCode].mediaTypes[0];
        }
      }
      return state;
    };
    this.getResponseCodeSelectOptions = () => {
      return this.responseCodeOptions.map(opt => {
        let t;
        if (isNaN(opt)) {
          t = I18n.text(`developer-docs-shared-components.response.exampleResponse.responseTypes.${opt}`, {
            defaultValue: opt
          });
        } else {
          t = I18n.text('developer-docs-shared-components.response.exampleResponse.responseTypes.http', {
            code: opt
          });
        }
        return {
          text: t,
          value: opt
        };
      });
    };
    this.onResponseCodeChange = ({
      target: {
        value
      }
    }) => {
      const mediaType = this.examples[value].mediaTypes.length ? this.examples[value].mediaTypes[0] : null;
      this.setState({
        selectedResponseCode: value,
        selectedResponseMediaType: mediaType
      });
    };
    this.onResponseMediaTypeChange = mediaType => {
      this.setState({
        selectedResponseMediaType: mediaType
      });
    };
    this.examples = getResponseExamples(props.operation, props.oas);
    this.responseCodeOptions = Object.keys(this.examples);
    this.responseCodeSelectOptions = this.getResponseCodeSelectOptions();
    this.state = this.getInitialState();
  }
  render() {
    const {
      selectedResponseCode,
      selectedResponseMediaType
    } = this.state;
    if (!this.examples || !this.examples[selectedResponseCode] || !this.examples[selectedResponseCode].mediaTypes) {
      return /*#__PURE__*/_jsx(View, {
        paddingInline: "400",
        as: "div",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.response.exampleResponse.noExamples"
        })
      });
    }
    const code = ((this.examples[selectedResponseCode].examples || {})[selectedResponseMediaType] || {}).code;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(UISelect, {
        buttonUse: "transparent",
        onChange: this.onResponseCodeChange,
        options: this.responseCodeSelectOptions,
        value: selectedResponseCode
      }), !code && selectedResponseCode === '204' && /*#__PURE__*/_jsx(View, {
        paddingInlineStart: "300",
        paddingBlockEnd: "300",
        as: "div",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "developer-docs-shared-components.response.response.noContent"
        })
      }), code && /*#__PURE__*/_jsx(LazyLoadWrapper, {
        mountOnce: true,
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(LanguagePicker, {
            languages: this.examples[selectedResponseCode].mediaTypes,
            selectedLanguage: selectedResponseMediaType,
            setLanguage: this.onResponseMediaTypeChange,
            value: code
          }), /*#__PURE__*/_jsx(CodeMirror, {
            value: code,
            mode: 'application/json',
            collapsible: true,
            height: 'auto'
          })]
        })
      })]
    });
  }
}
ExampleResponse.propTypes = {
  oas: OasPropType.isRequired,
  operation: OperationPropType.isRequired
};